<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="justify-center" color="black" dark>
        <div class="logo-img"></div>
        <div class="container-notification">
          <img class="align-center" src="/logo-mikro.png" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h1>Recibe lo último de nuestros canales</h1>
            <h2>¿Te gustaría recibir información sobre los estrenos y promociones de los canales de televisión de AMC Networks?</h2>
          </v-flex>
          <v-btn
            class="align-center-btn"
            width="340px"
            color="primary"
            @click="go(true); dialog = false;">Sí</v-btn>
          <v-btn class="align-center-btn" width="340px"
            @click="go(); dialog = false;">No</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data: () => ({
      dialog: true
    }),
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      ...mapActions(['updateUserPrivacy']),
      go(enableNotifications) {
        let allow_communications = false
        const privacy = JSON.parse(localStorage.getItem('privacy')) || null
        const terms = JSON.parse(localStorage.getItem('terms')) || null
        if (enableNotifications) allow_communications = true
          console.log('user:::', this.user, {
          id: this.user.id, allow_communications, privacy, terms
        })
        this.updateUserPrivacy({
          id: this.user.id, allow_communications, privacy, terms
        })
        this.$router.replace({ name: 'Home' })
      }
    }
  }
</script>

<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 136px);
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
</style>
<style>
  .align-center-btn * {
    width: 240px;
  }
</style>